import service from './axios';

// 获取客服联系方式列表
export const fetchCustomerServiceContactList = (params) => {
  return service({
    method: 'get',
    url: '/manage/customer-service-contacts',
    params
  });
};

// 获取客服联系方式详情
export const fetchCustomerServiceContactDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/customer-service-contacts/${id}`,
  });
};

// 新增客服联系方式
export const addCustomerServiceContact = (data) => {
  return service({
    method: 'post',
    url: '/manage/customer-service-contacts',
    data
  });
};

// 更新客服联系方式
export const updateCustomerServiceContact = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/customer-service-contacts/${id}`,
    data
  });
};

// 删除客服联系方式
export const deleteCustomerServiceContact = (id) => {
  return service({
    method: 'delete',
    url: `/manage/customer-service-contacts/${id}`,
  });
};

// 前端获取联系方式
export const getFrontendCustomerServiceContacts = () => {
  return service({
    method: 'get',
    url: '/front/customer-service-contacts'
  });
};
